import { store } from "../redux/store";
import Axios from "./axiosInstance";

export const http_request = async (
    url,
    method = "GET",
    body = {},
    checkToken = true,
    headers = {},
    message = { success: "", failure: "" },
    AxiosInstance = Axios
) => {

    let data = null;
    let authHeader = {};
    let token;

    try {
        if (checkToken) {
            if (store && store.getState().auth && (store.getState().auth.token || (store.getState().auth.admin && store.getState().auth.admin.jwt))) {

                token = store.getState().auth.token || store.getState().auth.admin.jwt;

                authHeader = {
                    // "Content-Type": "application/x-www-form-urlencoded",
                    // "Content-Type": "application/json",
                    // "Accept": "application/json",

                    'Authorization': `bearer ${token}`,
                    // 'Authorization': `Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIyMDIxMTI1NDU5MjY1MThMTVZSVEJLRUtHQmlnQiIsInF3QDEzIjoiMSIsImV4cCI6MTYxMjU2MzQwOCwiaWF0IjoxNjEyNTI3NDA4fQ.pPUTpyVBMRSBxMTgNnTgTY6kjKLbrsNkq8zFwjIH52E`,

                    // Authorization: "Bearer " + token,
                };

            } else {
                // dispatch(appStatusFailed("Token expired!"));
                return;
            }

        }

        switch (method.toUpperCase()) {
            case "GET":
                data = await AxiosInstance.get(url, {
                    headers: {
                        ...headers,
                        ...authHeader,
                    },
                });
                break;
            case "POST":
                data = await AxiosInstance.post(url, body, {
                    headers: {
                        ...headers,
                        ...authHeader,
                    },
                });
                break;
            case "PATCH":
                data = await AxiosInstance.patch(url, body, {
                    headers: {
                        ...headers,
                        ...authHeader,
                    },
                });
                break;
            case "PUT":
                data = await AxiosInstance.put(url, body, {
                    headers: {
                        ...headers,
                        ...authHeader,
                    },
                });
                break;
            case "DELETE":
                data = await AxiosInstance.delete(url, {
                    headers: {
                        ...headers,
                        ...authHeader,
                    },
                });
                break;
            default:
                data = await AxiosInstance.get(url, {
                    headers: {
                        ...headers,
                        ...authHeader,
                    },
                });
                break;
        }
    } catch (err) {
        console.log("URL ERRRO", url);
        console.warn(
            `An error occured while requesting a url : ${url} \n Error: ${err}`
        );
    } finally {
        if (data) {
            return data.data;
        }
    }
};
